module.exports = __webpack_public_path__ + "img/footer-center.3486edcb.png";